import Alert from "react-s-alert";
import _ from 'lodash';
import {
  push
} from 'react-router-redux'
import {I18nUtils} from "../../../i18n/I18nUtils";
import ExportCompanyDocumentsRequest from "../ws/ExportCompanyDocumentsRequest";
import {PsRoutes} from "../../shared/routing/Routes";
import RouterUtils from "../../shared/routing/RouterUtils";

export const EXPORT_DOCUMENTS_LOADING  = 'export-documents-loading';
export const EXPORT_DOCUMENTS_CLEAR  = 'export-documents-clear';

export const EXPORT_OUTSOURCE_OUTSOURCE_DOCUMENT  = 'export-outsource-outsource-document';
export const EXPORT_OUTSOURCE_WORKER_DOCUMENT     = 'export-outsource-worker-document';
export const EXPORT_OUTSOURCE_MACHINE_DOCUMENT    = 'export-outsource-machine-document';
export const EXPORT_OUTSOURCE_MONTHLY_DOCUMENT    = 'export-outsource-monthly-document';
export const EXPORT_OUTSOURCE_LINKED_DOCUMENT     = 'export-outsource-linked-document';

// ACTIONS

export const checkOutsourceDocument = (document, checked) => (dispatch) => {
  dispatch({
    type: EXPORT_OUTSOURCE_OUTSOURCE_DOCUMENT,
    payload: document,
    checked: checked,
  });
};

export const checkOutsourceDocuments = (documents, checked) => (dispatch) => {
  documents.forEach((document) => {
    dispatch({
      type: EXPORT_OUTSOURCE_OUTSOURCE_DOCUMENT,
      payload: document,
      checked: checked,
    });
  });
};

export const checkWorker = (worker, checked) => (dispatch) => {
  dispatch({
    type: EXPORT_OUTSOURCE_WORKER_DOCUMENT,
    payload: worker,
    checked: checked,
  });
};
export const checkWorkers = (workers, checked) => (dispatch) => {
  workers.forEach((worker) => {
    dispatch({
      type: EXPORT_OUTSOURCE_WORKER_DOCUMENT,
      payload: worker,
      checked: checked,
    });
  });
};

export const checkMachine = (machine, checked) => (dispatch) => {
  dispatch({
    type: EXPORT_OUTSOURCE_MACHINE_DOCUMENT,
    payload: machine,
    checked: checked,
  });
};
export const checkMachines = (machines, checked) => (dispatch) => {
  _.forEach(machines, (machine) => {
    dispatch({
      type: EXPORT_OUTSOURCE_MACHINE_DOCUMENT,
      payload: machine,
      checked: checked,
    });
  });
};

export const checkMonthlyDocument = (document, checked) => (dispatch) => {
  dispatch({
    type: EXPORT_OUTSOURCE_MONTHLY_DOCUMENT,
    payload: document,
    checked: checked,
  });
};
export const checkMonthlyDocuments = (documents, checked) => (dispatch) => {
  documents.forEach((document) => {
    dispatch({
      type: EXPORT_OUTSOURCE_MONTHLY_DOCUMENT,
      payload: document,
      checked: checked,
    });
  });
};

export const checkLinkedDocument = (document, checked) => (dispatch) => {
  dispatch({
    type: EXPORT_OUTSOURCE_LINKED_DOCUMENT,
    payload: document,
    checked: checked,
  });
};
export const checkLinkedDocuments = (documents, checked) => (dispatch) => {
  documents.forEach((document) => {
    dispatch({
      type: EXPORT_OUTSOURCE_LINKED_DOCUMENT,
      payload: document,
      checked: checked,
    });
  });
};

export const exportDocumentation = (outsource, outsourceDocumentsId, workersIds, machinesIds, monthlyDocuments, linkedDocuments) => (dispatch) => {

  new ExportCompanyDocumentsRequest(outsource.id, outsourceDocumentsId, workersIds, machinesIds, monthlyDocuments, linkedDocuments)
    .onPreExecution(() => {
      dispatch({ type: EXPORT_DOCUMENTS_LOADING, payload: true });
    })
    .onSuccess(response => {
      window.open( response.data.url, "_blank");
      Alert.success(I18nUtils.tr('TR_DOCUMENTACION_EXPORTADA_CORRECTAMENTE'));
      dispatch(push(RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, {id: outsource.id})))
      dispatch({ type: EXPORT_DOCUMENTS_CLEAR });
    })
    .onFail(error => {
      Alert.error(error || I18nUtils.tr('TR_ADD_OUTSOURCE_ERROR'));
    })
    .onPostExecution(() => {
      dispatch({ type: EXPORT_DOCUMENTS_LOADING, payload: false });
    })
    .execute();

};




// WEBPACK FOOTER //
// ./src/app/outsource/actions/exportOutsourceDocsActions.js